"use strict";

exports.__esModule = true;
var _ClockElement = require("./ClockElement");
Object.keys(_ClockElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClockElement[key]) return;
  exports[key] = _ClockElement[key];
});
var _ClockThumbnail = require("./ClockThumbnail");
Object.keys(_ClockThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClockThumbnail[key]) return;
  exports[key] = _ClockThumbnail[key];
});
var _ClockFields = require("./ClockFields");
Object.keys(_ClockFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClockFields[key]) return;
  exports[key] = _ClockFields[key];
});
var _ClockHeader = require("./ClockHeader");
Object.keys(_ClockHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClockHeader[key]) return;
  exports[key] = _ClockHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});